import React from 'react'
import { cn } from 'design-system'

const constants = {
  themes: {
    yellow: 'yellow',
    blue: 'blue',
    gray: 'gray',
    red: 'red',
    green: 'green',

    // aliases
    primary: 'yellow',
    secondary: 'blue',
    info: 'blue',
    error: 'red',
    success: 'green',
    warning: 'yellow'
  }
}

const ProgressBar = ({
  percent = 0,
  theme = constants.themes.primary,
  processing = false
}) => {
  const percentString = `${Math.ceil(percent)}%`
  const progressString = processing ? 'Processing...' : percentString

  return (
    <div
      className={cn('yd-progress-bar', {
        [`yd-progress-bar--${constants.themes[theme] || theme}`]: !!theme
      })}>
      <span className="sr-only" role="progressbar">
        {progressString}
      </span>
      <span className="yd-progress-bar__bar" style={{ width: percentString }} />
    </div>
  )
}

export default ProgressBar
